window.c24DomReady(function() {
    window.c24LpFrameJsReady.then(function() {
        window.c24LpCssLoaded.then(function() {
            let currentPosition = 1;

            function trackPPsetTeaser(direction = 0) {
                const totalTeasers = $('#c24-slider-bx > .fade').length;
                currentPosition += direction;

                if (currentPosition > totalTeasers) {
                    currentPosition = 1;
                }

                if (currentPosition < 1) {
                    currentPosition = totalTeasers;
                }

                const currentTeaserElement = $('#c24-slider-bx > .fade').eq(currentPosition - 1); // eq is 0-indexed

                if (currentTeaserElement.data('position') && currentTeaserElement.data('product') && currentTeaserElement.data('type')) {
                    let $name = 'ppset-teaser:' + currentTeaserElement.data('position') + ':' + currentTeaserElement.data('product') + ':' + currentTeaserElement.data('type');
                    window._paq.push([
                        'trackEvent',
                        window.c24Lp.getMatomoEventCategory(),
                        'ppset-teaser:show',
                        $name,
                    ]);
                }
            }

            $('#c24-slider-bx').bxSlider({
                mode: 'fade',
                auto: false,
                touchEnabled: window.c24LpIsMobile,
                onSliderLoad: function() {
                    $('.c24-home-slide').show();
                    trackPPsetTeaser();
                },
                onSlideBefore: function() {
                    window.Check24.homeTeaser.beforeSlide();
                    $('.duration-layer').hide();
                },
                onSlideAfter: function () {
                },
                onSlideNext: function () {
                    trackPPsetTeaser(1);
                },
                onSlidePrev: function () {
                    trackPPsetTeaser(-1);
                },
            });
            if (document.cookie.indexOf('ppset') >= 0) {
                window.Check24.homeTeaser.ppset = true;
            }
        });
    });
});
